export class StaticLenguage {
    appTitulo = '';
    formNombre = '';
    formPalabrasClave = '';
    formUnidadesAcademicas = '';
    formTipo = '';
    formTitulo = '';
    regresar = '';
    textInicio1 = '';
    textInicio2 = '';
    verMas = '';
    tipos = [];
    constructor() {}
}



// WEBPACK FOOTER //
// ./src/app/shared/dominio/staticLenguage.ts